<template>
  <div
    id="singin"
    class="d-flex align-center justify-center text-center bg-image"
    v-bind:style="{ 'background-image': 'url(' + bgImage + ')' }"
  >
    <v-card class="py-15 px-10" max-width="450">
      <div class="svg">
        <img width="370" :src="logo" />
      </div>
      <div class="mt30"></div>
      <form @submit.prevent="submit">
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="userName"
              label="Email"
              type="email"
              prepend-icon="mdi-account-outline"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-text-field
              v-model="password"
              label="Senha"
              type="password"
              prepend-icon="mdi-lock-outline"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <div v-if="false" class="d-flex justify-space-between mt-5 justify-center">
          <v-checkbox v-model="memoryLogin" label="Lembrar"></v-checkbox>

          <div class="mt-3">
            <router-link to="" class="recovery-pass">Recuperar senha</router-link>
          </div>
        </div>
        <div class="mt-10">
          <v-btn large color="success" type="submit" :loading="loading"> Entrar </v-btn>
        </div>
      </form>
    </v-card>

    <v-snackbar :timeout="3000" :value="errors.length" absolute left shaped top color="error">
      <p v-for="error in errors" :key="error">
        {{ error }}
      </p>
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import logoLoginPNG from '@/assets/img/Logo_LoginML.png';

export default {
  name: 'SingIn',
  data: () => ({
    logo: logoLoginPNG,
    errors: [],
    errorsType: 'error',
    bgImage: require('../assets/img/bg-login.jpg'),
    userName: '',
    password: '',
    memoryLogin: false,
    loading: false
  }),
  methods: {
    ...mapActions('LoginStore', ['login']),
    ...mapMutations('LoginStore', ['setLogged', 'setUserLogged']),
    async submit() {
      const params = {
        userName: this.userName,
        password: this.password
      };
      this.loading = true;

      try {
        const status = await this.login(params);

        if (status.success) {
          localStorage.setItem('user', JSON.stringify(status.data));
          localStorage.setItem('accessToken', status.data.accessToken);
          this.setUserLogged(status.data);
          this.setLogged(true);
          this.$router.push('/start');
          const role = status.data.userToken.claims[0].value;
          setTimeout(() => {
            if (role === 'Admin') {
              this.$router.push('/users');
            } else if (role === 'Operador') {
              this.$router.push('/couriers');
            } else if (role === 'Embarcador') {
              this.$router.push('/shipper-deliveries');
            }
            this.loading = false;
          }, 0);
        } else {
          this.errors = status.errors;
          setTimeout(() => {
            this.errors = [];
          }, 3000);
        }

        this.loading = false;
      } catch (err) {
        console.error(err);
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#singin {
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  position: absolute;

  .recovery-pass {
    font-weight: bold;
    color: $--color-secundary;
    margin: 0;
    padding: 0;
    font-size: 12px;
  }

  h1 {
    color: $--color-primary;
  }

  .svg {
    zoom: 0.8;
  }
}
.bg-image {
  background-size: cover;
}
</style>
